import { useState } from 'react'

import {
  getElevationClassName,
  getGapClassName,
  type ThemeElevation,
  type ThemeGapValue,
} from '@mntn-dev/ui-theme'

import { type UseSpacingProps, useSpacing } from '../../hooks/use-spacing.ts'
import { createContext } from '../../utils/context.ts'

type UseSurfaceProps = UseSpacingProps & {
  divide?: boolean
  elevation?: ThemeElevation
  gap?: ThemeGapValue
}

function useSurface(props: UseSurfaceProps) {
  const { divide = true } = props
  const [hasSurfaceChildren, setHasSurfaceChildren] = useState(false)
  const { marginClassName, paddingClassName } = useSpacing(props)

  const elevationClassName = getElevationClassName(props.elevation)
  const gapClassName = getGapClassName({ gap: props.gap })

  return {
    divide,
    elevationClassName,
    gapClassName,
    hasSurfaceChildren,
    marginClassName,
    paddingClassName,
    setHasSurfaceChildren,
  }
}

const [SurfaceProvider, useSurfaceContext] = createContext<
  ReturnType<typeof useSurface>
>({ name: 'SurfaceContext' })

export { SurfaceProvider, type UseSurfaceProps, useSurface, useSurfaceContext }
